import moment from 'moment'
require('moment-duration-format')
moment.locale('ja')
export default {
  methods: {
    scheduleLinkFormat () {
      var today = moment(new Date).format('YYYY-MM-DD')
      if (moment(today).isBefore('2018-10-25')) {
        return 'day25'
      } else if (moment(today).isAfter('2018-11-03')) {
        return 'day03'
      } else {
        return 'day' + moment(new Date).format('DD')
      }
    }
  },
  filters: {
    datedayformat (value) {
      return moment(value).format('MM/DD') + '[' + moment(value).locale('en').format('ddd').toUpperCase() + ']'
    },
    dateformat (value) {
      return moment(value).format('MM/DD')
    },
    datedotformat (value) {
      return moment(value).format('MM.DD')
    },
    dateidformat (value) {
      return 'date' + moment(value).format('DD')
    },
    dayformat (value) {
      return moment(value).locale('en').format('ddd').toUpperCase()
    },
    timeformat (value) {
      return moment.duration(value, 'ms').format('H:mm', { trim: false })
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixins/momentFormat.js